"use client";
import { toggleVideoModalOpen } from "@/theme/redux/features/videoModalSlice";
import { useAppDispatch } from "@/theme/redux/hooks";
import React from "react";
import CustomGsapHeaderAnimate from "../utils/CustomGsapHeaderAnimate";
import BounceAnimatedBtn from "../utils/BounceAnimatedBtn";
import "./VideoSection.scss";

const VideoSection = () => {
  // const dispatch = useAppDispatch();
  // const openVideoModal = () => {
  //   dispatch(toggleVideoModalOpen());
  // };
  return (
    <section
      className="rv-20-video_section about_banner_image"
      style={{
        backgroundImage: `url("/assets/hindustanpurefoods/about/about-banner-1.webp")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-7 col-lg-7 col-sm-7">
            <div className="rv-20-video_section_heading">
              {/* <CustomGsapHeaderAnimate>
                <p
                  className="rv-20-video_sub_title rv-text-anime d-flex"
                  style={{ zIndex: "999" }}
                >
                  <span></span> More Information
                </p>
              </CustomGsapHeaderAnimate> */}
              <CustomGsapHeaderAnimate>
                <h2
                  className="rv-20-video_section_title rv-text-anime about_banner_title_text"
                  style={{ zIndex: "9" }}
                >
                  Fueling Health with the Power of Pure Millet
                </h2>
              </CustomGsapHeaderAnimate>
            </div>
          </div>
          {/* <div className="col-md-5 col-lg-5 col-sm-5">
            <div className="rv-20-video_button">
              <BounceAnimatedBtn>
                <a
                  className="video_btn my-video-links"
                  role="button"
                  // onClick={openVideoModal}
                >
                  <i className="fas fa-play"></i>
                </a>
              </BounceAnimatedBtn>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
